import { doHttp, doHttp2 } from '../utils/common'
import { HTTP_TYPE_GET } from '../utils/config'

/**
 * 追加打印
 * @param labelPrintId
 * @param num
 * @return {*}
 */
export function apiAdd (labelPrintId, num) {
  let params = {
    labelPrintId,
    num
  }
  return doHttp('/labelPrint/addPrint.action', HTTP_TYPE_GET, params)
}

/**
 * 详情
 * @param labelPrintId
 * @return {*}
 */
export function apiDetail (labelPrintId) {
  let params = {
    labelPrintId
  }
  return doHttp('/labelPrint/detail.action', HTTP_TYPE_GET, params)
}

/**
 * 获取打印内容
 * @param labelPrintId
 * @return {*}
 */
export function apiList (labelPrintId) {
  let params = { labelPrintId }
  return doHttp('/labelPrint/list.action', HTTP_TYPE_GET, params)
}

/**
 * 打印状态更新
 * @param labelPrintId
 */
export function apiUpdateStatus (labelPrintId, num = 10) {
  let params = {
    labelPrintId,
    num
  }
  return doHttp('/labelPrint/updateStatus.action', HTTP_TYPE_GET, params)
}

/**
 * 关闭jcp
 */
export function jcpExit () {
  return doHttp2('http://127.0.0.1:31227/api?type=exit', HTTP_TYPE_GET)
}

/**
 * 标签预览
 * @param labelId
 * @param productDate
 */
export function view (labelId, productDate) {
  let params = {
    labelId,
    productDate
  }
  return doHttp('/labelPrint/view.action', HTTP_TYPE_GET, params)
}

/**
 * 获取标签模板
 * @param labelPrintId
 */
export function getLabelListByPrintId (labelPrintId) {
  let params = {
    labelPrintId
  }
  return doHttp('/labelPrint/label/list.action', HTTP_TYPE_GET, params)
}

/**
 * 设置标签模板
 * @param labelPrintId
 */
export function setLabel (labelPrintId, labelId) {
  let params = {
    labelPrintId,
    labelId
  }
  return doHttp('/labelPrint/setLabel.action', HTTP_TYPE_GET, params)
}
